const PERMISSION_KEY= "company:news_summary";
const PAGE_URL = {
    NEWS_SUMMARY_PAGE: "/admin/company/news-summary"
}

export {PERMISSION_KEY, PAGE_URL}

